module.exports = __webpack_public_path__ + "img/morning-background.285c6a38.png";